const DEFAULT_FIRST_PART_POOL = [
  'ordinary',
  'faithful',
  'clever',
  'agile',
  'squeaky',
  'savvy',
  'wild',
  'fearless',
  'colored',
  'big',
  'annoying',
  'fast',
  'talking',
  'tenacious',
  'invisible',
  'suspicious',
  'cute',
  'sleepy',
  'lazy',
  'powerful',
  'strong',
  'white',
  'marvelous',
  'brilliant',
  'sly',
  'friendly',
  'protected',
  'soft',
];

const DEFAULT_LAST_PART_POOL = [
  'cat',
  'dog',
  'rat',
  'raven',
  'derret',
  'cavy',
  'pig',
  'wolf',
  'honey badger',
  'mantis shrimp',
  'whale',
  'cougar',
  'cheetah',
  'parrot',
  'koala',
  'bat',
  'raccoon',
  'wombat',
  'panda',
  'sloth',
  'monitor_lizard',
  'python',
  'chinchilla',
  'platypus',
  'chimpanzee',
  'fox',
  'bear',
  'battleship',
  'alpaca',
];

export const generateRandomName = ({
  firstPartPool = DEFAULT_FIRST_PART_POOL,
  lastPartPool = DEFAULT_LAST_PART_POOL,
}: {
  firstPartPool?: string[];
  lastPartPool?: string[];
} = {}) => {
  let firstPart =
    firstPartPool[Math.floor(Math.random() * firstPartPool.length)];
  let lastPart = lastPartPool[Math.floor(Math.random() * lastPartPool.length)];
  return `${firstPart}_${lastPart}`;
};
